"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = require("../Button/Button");
var _reactChildrenUtilities = require("react-children-utilities");
var _Merger = _interopRequireDefault(require("../../common/Merger"));
var _ObjectValidator = _interopRequireDefault(require("../../common/ObjectValidator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.form {\n  text-align: start;\n  margin-bottom: 1.5rem; }\n  .form .bx--grid {\n    padding: 0; }\n  @media (min-width: 42rem) {\n    .form .bx--grid.reset-spacings .bx--row div[class*=\"bx--col\"].fields-column:nth-child(1) {\n      padding-right: 0.5rem; }\n    .form .bx--grid.reset-spacings .bx--row div[class*=\"bx--col\"].fields-column:nth-child(2) {\n      padding-left: 0.5rem; }\n    .form .form-buttons .button {\n      margin-right: 1rem; }\n      .form .form-buttons .button:last-child {\n        margin-right: 0; }\n    .form.multi-page .form-buttons {\n      float: right; }\n      .form.multi-page .form-buttons button {\n        margin-right: 0;\n        margin-left: 1rem; }\n        .form.multi-page .form-buttons button:first-of-type {\n          margin-left: 0; } }\n  @media (max-width: 671px) {\n    .form .form-buttons button {\n      width: 100%;\n      max-width: none;\n      margin-bottom: 16px; }\n    .form.multi-page .form-buttons {\n      float: none; } }\n";
  const fileName = "Form_Form";
  const element = document.querySelector("style[data-sass-component='Form_Form']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Form = props => {
  const classNames = ['form'];
  if (props.multiPage) {
    classNames.push('multi-page');
  }
  const validateIsElementEmpty = element => {
    const type = element.props.type;
    const value = element.props.value;
    const isOneOf = types => types.includes(type);
    const errors = {};
    if (isOneOf(['TextInput', 'NumberInput', 'DateInput', 'EmailInput', 'PhoneInput', 'WebsiteInput', 'TextArea']) && value === '') {
      errors[element.props.id] = 'form.input.error.empty';
      return errors;
    }
    if (type === 'Dropdown' && !value) {
      errors[element.props.id] = 'form.input.error.empty';
      return errors;
    }
    if (type === 'MultiselectDropdown') {
      const activeItems = element.props.items.filter(item => item.active);
      const hasActiveItem = activeItems.length > 0;
      if (!hasActiveItem) {
        errors[element.props.id] = 'form.input.error.empty';
        return errors;
      }
    }
    if (type === 'MultiInput') {
      const withValueChildren = element.props.children.filter(child => child && child.props.value);
      const areAllEmpty = !withValueChildren.length;
      if (!areAllEmpty) {
        return errors;
      }
      element.props.children.forEach(child => {
        if (child) {
          errors[child.props.id] = 'form.input.error.empty';
        }
      });
      return errors;
    }
    return errors;
  };
  const validateRequiredElements = () => {
    let errors = {};
    (0, _reactChildrenUtilities.deepForEach)(props.children, child => {
      if (child && child.props.required) {
        const emptyErrors = validateIsElementEmpty(child);
        if (!_ObjectValidator.default.isEmpty(emptyErrors)) {
          errors = _Merger.default.mergeObjectsImmutable(errors, emptyErrors);
        }
      }
    });
    return errors;
  };
  const getCurrentFieldErrors = () => {
    let errors = {};
    (0, _reactChildrenUtilities.deepForEach)(props.children, child => {
      if (child && child.props.invalidText) {
        errors[child.props.id] = child.props.invalidText;
      }
    });
    return errors;
  };
  const onClickPrimaryButton = () => {
    const currentFieldErrors = getCurrentFieldErrors();
    const requiredErrors = validateRequiredElements();
    const errors = _Merger.default.mergeObjectsImmutable(currentFieldErrors, requiredErrors);
    const hasErrors = !_ObjectValidator.default.isEmpty(errors);
    if (hasErrors) {
      if (props.onErrors) {
        props.onErrors(errors);
      }
      return;
    }
    props.onClickPrimaryButton();
  };
  const primaryButton = /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: onClickPrimaryButton
  }, props.primaryButtonLabel);
  const secondaryButton = props.onClickSecondaryButton ? /*#__PURE__*/_react.default.createElement(_Button.Button, {
    kind: 'secondary',
    onClick: () => props.onClickSecondaryButton()
  }, props.secondaryButtonLabel) : null;
  const buttonsContainerClassname = 'form-buttons';
  const buttonsContainer = !props.multiPage ? /*#__PURE__*/_react.default.createElement("div", {
    className: buttonsContainerClassname
  }, primaryButton, secondaryButton) : /*#__PURE__*/_react.default.createElement("div", {
    className: buttonsContainerClassname
  }, secondaryButton, primaryButton);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames.join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--grid reset-spacings"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--row"
  }, props.children), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'bx--col'
  }, buttonsContainer))));
};
Form.propTypes = {
  primaryButtonLabel: _propTypes.default.string.isRequired,
  onClickPrimaryButton: _propTypes.default.func.isRequired,
  multiPage: _propTypes.default.bool,
  secondaryButtonLabel: _propTypes.default.string,
  onClickSecondaryButton: _propTypes.default.func,
  onErrors: _propTypes.default.func
};
var _default = exports.default = Form;